import { AvailableShowcasesResponse } from '../../@types';

export function showcasesAvailablePresenter(availableShowcases: AvailableShowcasesResponse) {
  const updatedShowcases = availableShowcases?.data?.map((availableShowcase) => {
    availableShowcase.isFetched = false;
    return availableShowcase;
  });

  return { data: updatedShowcases || [] };
}
